var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodleClassroom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-7.101 0 824 175.32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_830_745",
    x1: 770.84,
    y1: 157.213,
    x2: 770.84,
    y2: 175.605,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.980012, 0, 0, 0.980012, 8.121098, 1.719868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF360C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF360C",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_830_745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(820.848572, 0, 0, 820.844604, 623.562965, 5.861372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "matrix(0.294913, 0, 0, 0.295069, 0, 30.91)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.61,309.77V201.51q0-33.94-28-33.95t-28.06,33.95V309.77H178.4V201.51q0-33.94-27.57-33.95-28.05,0-28,33.95V309.77H67.67V195.12q0-35.43,24.6-53.63,21.66-16.25,58.56-16.25,37.41,0,55.12,19.19,15.26-19.19,55.62-19.19,36.9,0,58.54,16.25,24.6,18.19,24.61,53.63V309.77Z",
    style: {
      fill: "#f98012"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.1,309.27V0h55.16V309.27Z",
    style: {
      fill: "#f98012"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.8,309.27V291.05q-7.39,9.84-25.11,15.76a92.81,92.81,0,0,1-30.05,5.41q-39.4,0-63.28-27.09t-23.89-67c0-26.25,7.76-48.3,23.4-66,13.85-15.65,36.35-26.59,62.29-26.59,29.22,0,46.28,11,56.64,23.63V0h53.68V309.27Zm0-102.92q0-14.78-14-28.33T852,164.47q-21.16,0-33.48,17.24-10.85,15.3-10.84,37.43,0,21.68,10.84,36.94,12.3,17.75,33.48,17.73,12.81,0,27.83-12.07t15-24.86Z",
    style: {
      fill: "#f98012"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.57,314.19q-41.87,0-69.19-26.59T552,219.14q0-41.83,27.34-68.45t69.19-26.59q41.85,0,69.44,26.59t27.58,68.45q0,41.88-27.58,68.46T648.57,314.19Zm0-145.77q-19.94,0-30.65,15.1T607.21,219.4q0,20.78,10,35.13,11.46,16.34,31.4,16.32T680,254.53q10.46-14.34,10.46-35.13t-10-35.13Q669,168.41,648.57,168.42Z",
    style: {
      fill: "#f98012"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.13,314.19q-41.86,0-69.2-26.59T352.6,219.14q0-41.83,27.33-68.45t69.2-26.59q41.83,0,69.44,26.59t27.57,68.45q0,41.88-27.57,68.46T449.13,314.19Zm0-145.77q-19.94,0-30.66,15.1T407.76,219.4q0,20.78,10,35.13,11.46,16.34,31.41,16.32t31.39-16.32Q491,240.19,491,219.4t-10-35.13Q469.56,168.41,449.13,168.42Z",
    style: {
      fill: "#f98012"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.58,235.89c1.18,13.13,18.25,41.37,46.31,41.37,27.31,0,40.23-15.77,40.87-22.16l58.11-.5c-6.34,19.39-32.1,60.58-100,60.58-28.24,0-54.08-8.79-72.64-26.35s-27.82-40.45-27.82-68.7q0-43.83,27.82-69.68t72.16-25.85q48.25,0,75.34,32,25.13,29.53,25.12,79.28Zm90.13-34c-2.3-11.83-7.23-21.49-14.77-29.06q-12.82-12.3-29.55-12.31-17.25,0-28.82,11.82t-15.5,29.55Z",
    style: {
      fill: "#f98012"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.74,116.9l54.74-40-.7-2.44C130,86.57,85.08,95.15,0,144.47l.79,2.24,6.76.07c-.62,6.81-1.7,23.64-.32,48.95-9.44,27.32-.24,45.88,8.4,66.07,1.37-21,1.23-44-5.22-66.89-1.35-25.14-.24-41.67.37-48.1l56.4.54a258,258,0,0,0,1.67,33.06c50.4,17.71,101.09-.06,128-43.72C189.38,128.32,174.74,116.9,174.74,116.9Z",
    style: {
      fill: "#333"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 513.97 81.895 L 513.97 97.96 L 496.225 97.96 L 496.225 118.855 L 477.85 118.855 L 477.85 97.96 L 460 97.96 L 460 81.895 L 477.85 81.895 L 477.85 61 L 496.225 61 L 496.225 81.895 L 513.97 81.895 Z",
    fill: "#FF0000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 37.79,
    width: 363,
    height: 93,
    fill: "url(#pattern0)",
    x: 6.867
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 634.794 19.894 L 797.565 19.894 L 797.565 155.538 L 634.794 155.538 L 634.794 19.894 Z",
    fill: "#0F9D58",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 752.353 92.238 C 757.967 92.238 762.526 87.679 762.526 82.064 C 762.526 76.45 757.967 71.891 752.353 71.891 C 746.738 71.891 742.179 76.45 742.179 82.064 C 742.179 87.679 746.738 92.238 752.353 92.238 Z M 752.353 99.019 C 741.463 99.019 729.746 104.785 729.746 111.944 L 729.746 119.367 L 774.96 119.367 L 774.96 111.944 C 774.96 104.785 763.242 99.019 752.353 99.019 Z M 680.009 92.238 C 685.623 92.238 690.182 87.679 690.182 82.064 C 690.182 76.45 685.623 71.891 680.009 71.891 C 674.395 71.891 669.836 76.45 669.836 82.064 C 669.836 87.679 674.396 92.238 680.009 92.238 Z M 680.009 99.019 C 669.119 99.019 657.401 104.785 657.401 111.944 L 657.401 119.367 L 702.616 119.367 L 702.616 111.944 C 702.617 104.785 690.898 99.019 680.009 99.019 Z",
    fill: "#57BB8A",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 716.18 83.195 C 723.678 83.195 729.744 77.129 729.744 69.631 C 729.744 62.134 723.678 56.066 716.18 56.066 C 708.682 56.066 702.616 62.133 702.616 69.631 C 702.616 77.128 708.682 83.195 716.18 83.195 Z M 716.18 92.238 C 700.921 92.238 684.53 100.338 684.53 110.323 L 684.53 119.366 L 747.83 119.366 L 747.83 110.323 C 747.831 100.338 731.44 92.238 716.18 92.238 Z",
    fill: "#F7F7F7",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 734.265 146.495 L 774.959 146.495 L 774.959 155.539 L 734.265 155.539 L 734.265 146.495 Z",
    fill: "#F1F1F1",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 802.088 1.809 L 630.273 1.809 C 622.775 1.809 616.709 7.875 616.709 15.373 L 616.709 160.058 C 616.709 167.557 622.775 173.623 630.273 173.623 L 802.087 173.623 C 809.585 173.623 815.652 167.557 815.652 160.058 L 815.652 15.373 C 815.653 7.875 809.586 1.809 802.088 1.809 Z M 797.566 155.538 L 634.794 155.538 L 634.794 19.894 L 797.566 19.894 L 797.566 155.538 L 797.566 155.538 Z",
    fill: "#F4B400",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M 802.088 1.809 L 630.273 1.809 C 622.775 1.809 616.709 7.875 616.709 15.373 L 616.709 16.503 C 616.709 9.006 622.775 2.939 630.273 2.939 L 802.087 2.939 C 809.585 2.939 815.652 9.005 815.652 16.503 L 815.652 15.373 C 815.653 7.875 809.586 1.809 802.088 1.809 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M 802.088 172.494 L 630.273 172.494 C 622.775 172.494 616.709 166.428 616.709 158.929 L 616.709 160.059 C 616.709 167.557 622.775 173.623 630.273 173.623 L 802.087 173.623 C 809.585 173.623 815.652 167.557 815.652 160.059 L 815.652 158.929 C 815.653 166.428 809.586 172.494 802.088 172.494 Z",
    fill: "#BF360C",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 774.884 155.539 L 734.191 155.539 L 752.276 173.624 L 792.932 173.624 L 774.884 155.539 Z",
    fill: "url(#paint0_linear_830_745)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M 634.794 18.764 L 797.565 18.764 L 797.565 19.894 L 634.794 19.894 L 634.794 18.764 Z",
    fill: "#263238",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M 634.794 155.539 L 797.565 155.539 L 797.565 156.669 L 634.794 156.669 L 634.794 155.539 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 802.088 1.809 L 630.273 1.809 C 622.775 1.809 616.709 7.875 616.709 15.373 L 616.709 160.058 C 616.709 167.557 622.775 173.623 630.273 173.623 L 802.087 173.623 C 809.585 173.623 815.652 167.557 815.652 160.058 L 815.652 15.373 C 815.653 7.875 809.586 1.809 802.088 1.809 Z",
    fill: "url(#paint1_radial_830_745)",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodleClassroom);
export default __webpack_public_path__ + "static/media/moodle_classroom.3782f56c514becb8abd56ff8186b9444.svg";
export { ForwardRef as ReactComponent };